/* Corrections lingala validées sur /pro/lingala → appliquées à chaud (i18n, manifeste, alertes, signes, suivi). */
import { dict } from "./i18n";
import { GESTES } from "../pages/CaregiverAlerts";
import { SIGNES } from "../pages/WorryMode";
import { ETATS } from "../components/FollowupCard";
import { api } from "./api";

const KEY = "bc_ln_overrides";
let current = {};
try { current = JSON.parse(localStorage.getItem(KEY) || "{}").overrides || {}; } catch { current = {}; }

export const ov = (key, fallback) => current[key] ?? fallback;
export const overridesCount = () => Object.keys(current).length;

function setNested(obj, path, value) {
  const parts = path.split(".");
  let o = obj;
  for (const p of parts.slice(0, -1)) { if (!o[p] || typeof o[p] !== "object") return; o = o[p]; }
  if (typeof o[parts.at(-1)] === "string") o[parts.at(-1)] = value;
}

/** Applique les corrections aux constantes en mémoire (le manifeste est corrigé à la lecture via `ov`). */
export function applyOverrides(map = current) {
  current = map;
  for (const [k, v] of Object.entries(map)) {
    const [src, ...rest] = k.split(":");
    if (src === "i18n") setNested(dict.ln, rest.join(":"), v);
    else if (src.startsWith("i18n@")) { const d = dict[src.split("@")[1]]; if (d) setNested(d, rest.join(":"), v); }
    else if (src === "alerts") { const [type, part] = rest; const g = GESTES[type]; if (!g) continue; if (part === "titre") g.ln = v; else { const i = Number(part.replace("geste", "")) - 1; if (g.gestes[i]) g.gestes[i].ln = v; } }
    else if (src === "urgence") { const s = SIGNES.find((x) => x.code === rest[1]); if (s) s.ln = v; }
    else if (src === "suivi") { const e = ETATS.find((x) => x.code === rest[1]); if (e) e.ln = v; }
  }
  window.dispatchEvent(new CustomEvent("bc-overrides-applied", { detail: { count: Object.keys(map).length } }));
}

export async function refreshOverrides() {
  try {
    const { data } = await api.get("/lingala/overrides");
    localStorage.setItem(KEY, JSON.stringify({ overrides: data.overrides, maj: data.maj, at: new Date().toISOString() }));
    applyOverrides(data.overrides);
    return data.count;
  } catch { applyOverrides(current); return overridesCount(); }
}

/** Texte lingala d'une étape d'exercice, corrigé si une correction validée existe. */
export const stepLn = (exId, step, aidant = false) => ov(`manifest:${exId}:${step.n}:${aidant ? "aidant" : "text"}`, aidant ? step.text_aidant_ln : step.text_ln);
